import React from 'react'

import './style.scss'

const Tooltip = (props) => {
  return <fil-tooltip {...props} />
}

Tooltip.propTypes = {}

Tooltip.defaultProps = {}

export default Tooltip
